/**
 * Converts a record with string keys and boolean values to an array of strings
 * containing only the keys where the value is true.
 * @param record - Object with string keys and boolean values
 * @returns Array of strings containing keys with true values
 */
export const convertRecordStringBooleanToStringArray = (
  record: Record<string, boolean>
): string[] => {
  return Object.keys(record).filter(key => record[key]);
};

/**
 * Validates a Vehicle Identification Number (VIN) against the standard format.
 * A valid VIN consists of 17 characters with 8 alphanumeric chars, followed by 1 digit,
 * followed by 2 letters, and lastly 6 digits. Letters I, O, and Q are excluded.
 * @param vin - Vehicle Identification Number to validate
 * @returns Whether the VIN is valid
 */
export function validateVin(vin: string): boolean {
  const regex = /^[A-HJ-NPR-Z\d]{8}\d{1}[A-HJ-NPR-Z]{2}\d{6}$/;
  return vin.toUpperCase().match(regex) !== null;
}

/**
 * Validates if a string is a properly formatted URL with http or https protocol.
 * @param url - URL string to validate
 * @returns Whether the URL is valid
 */
export const isValidUrl = (url: string): boolean => {
  if (!url) return false;

  // This regex validates URLs with the following requirements:
  // - Must start with http:// or https://
  // - Domain must have at least two parts (example.com)
  // - TLD must be at least 2 characters
  // - Allows subdomains, paths, query parameters, and fragments
  // - Query params and fragments can appear with or without a preceding path
  const urlRegex =
    /^https?:\/\/([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(\/[^\s?#]*)?([?#][^\s]*)?$/i;

  return urlRegex.test(url);
};
